// extracted by mini-css-extract-plugin
export var footer = "styles-module--footer--a2167";